import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import DivBottom from '../userNotAuth/components/divBottom'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

function EditArtistSuccess() {
    window.scrollTo(0, 0)
    const navigate = useNavigate()
    const redux = useSelector((state) => state.creaArtista.value)

    const [tipoCucinaArr, setTipoCucinaArr] = useState([])

    const grid = { display: 'grid', gridTemplateColumns: '.3fr 1fr ', gap: '5px' }

    function controlNavbar() {
        if (window.scrollY < 30) { window.scrollTo(0, 31) }
    }

    useEffect(() => {
        console.log('redux:', redux)
        window.addEventListener('scroll', controlNavbar)
        return () => { window.removeEventListener('scroll', controlNavbar) }
    }, [redux])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <AuthProvider />
        <br /><br /><br /><br />
        <h3 className='mt-3 container'>Profilo FoodTruck modificato con successo!</h3>

        <div className='container mt-5' style={{ marginBottom: '3rem' }}>
            <p className='fs-6' style={{ fontWeight: '600' }}>
                Il tuo profilo di FoodTruck è stato modificato ma prima di essere pubblicato dovrà essere approvato
                dal nostro staff.<br />
            </p>

            <hr />
            <div style={grid}>
                <div>Nome: </div> <div>{redux.nome}</div>
            </div>

            <div style={grid}>
                <div>Regione: </div> <div>{redux.regione}</div>
                <div>Città: </div> <div>{redux.città}</div>
                <div>Descr: </div> <div><i>{redux.descrizione}</i></div>
                <div>Specialità: </div><div>{redux.specialità}</div>
            </div>

            {redux.tipoCucina.length !== 0 &&
                <div style={grid} className='mt-3'>
                    <div>Tipologia:</div>
                    <div>
                        {tipoCucinaArr.map((elem, index) => (
                            <span key={index}>{elem}{index < redux.tipoCucina.length - 1 && <span>, </span>}
                            </span>
                        ))
                        }
                    </div>
                </div>
            }

            {redux.telefono !== '' &&
                <div style={grid} className='mt-3'>
                    <div>Telefono: </div> <div>{redux.telefono}</div>
                </div>
            }
            <div style={grid}>
                <div>Email: </div> <div>{redux.email}</div>
            </div>
            {redux.url !== '' &&
                <div style={grid}>
                    <div>Url: </div> <div style={{}}>{redux.url.substring(0, 35)}...</div>
                </div>
            }
            {redux.fb !== '' &&
                <div style={grid}>
                    <div>fb: </div> <div style={{}}>{redux.fb.substring(0, 35)}...</div>
                </div>
            }
            {redux.youtube !== '' &&
                <div style={grid}>
                    <div>youtube: </div> <div style={{}}>{redux.youtube.substring(0, 35)}...</div>
                </div>
            }
            <hr />
            {redux.foto.length !== 0 &&
                <div className='mt-4'>
                    <p>Immmagini caricate:</p>
                    <div className='mt-3' style={{ display: 'flex' }}>
                        {redux.foto.map((elem, index) => (
                            <div key={index} style={{ display: 'grid', gridTemplateColumns: '0.8fr 0.8fr 0.8fr', gap: '5px' }}>
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} width={110} height={110} />
                            </div>
                        ))}
                    </div>

                </div>
            }
            {redux.video &&
                <div className='mt-3'>
                    <p className='mt-1'>Video caricato:</p>
                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${redux.video}`} style={{ width: '144px', height: '80px', borderRadius: '5px' }} controls />
                </div>
            }
            <br />
            <div style={{ float: 'right' }}>
                <button className='btn btn-secondary' onClick={() => {
                    navigate('/', { replace: true })
                }}>
                    ⇒ Home
                </button>
            </div>
        </div>
        <DivBottom />
    </>)
}
export default EditArtistSuccess
